import React from "react";
import { MetaTags } from "react-meta-tags";
import { getLink, getWebpImage } from "../../../../Common/functions";
import "../../BlogCSS/styles.css";

function Blog_50_1() {
  return (
    <div className="blog-main-container">
      <MetaTags>
        <title>
          How can publicly traded companies start sustainability reporting ?
        </title>
        <meta
          name="description"
          content="ESG reporting is an important part of modern corporate reporting. It focuses on the modern environment. social and governance framework."
        />
        <meta
          property="og:title"
          content="UpdaptCSR | Sustainability Platform"
        />
        <script type="application/ld+json" async>
          {/* {JSON.stringify(articleSchema)}
          {JSON.stringify(breadcrumbsSchema)} */}
        </script>
      </MetaTags>

      <div className="blog-title">
        How can publicly traded companies start sustainability reporting ?<br />
        - A practical checklist
      </div>
      <div className="blog-author-details">
        <div className="blog-author-right">
          <div className="blog-author-top">
            <div className="blog-author-name">Subash M</div>
          </div>
          <div className="blog-author-bottom">
            <div className="blog-month">December 05, 2025</div>
            <div className="blog-read-time">7 min read</div>
          </div>
        </div>
      </div>
      <p>
        {getWebpImage(
          "cluster_1.webp",
          "How can publicly traded companies start sustainability reporting?"
        )}
      </p>
      <p>
        <div className="blog-sub-heading">Introduction</div>
        <b>Why should corporations not delay? </b>
        <br />
        If the corporation delays reporting, this can lead to negative
        consequences. This may include the damage to reputation. They will lose
        the investors' trust. It is a regulatory expectation. Many stakeholders
        demand transparency. Starting doesn't require a massive transformation.
        A base line report can also help to show intent and efforts. It will
        also help to grow. ESG reporting is an important part of modern
        corporate reporting. It focuses on the modern
        {getLink(" environmental, social, and governance", "/")} framework. It
        is useful to maintain the investor’s trust. Even though it seems
        complex, starting small can make a huge difference. They help to
        communicate progress effectively.{" "}
        {getLink(" ESG reporting", "/solutions/esg-reporting")} helps in
        consistent growth too. Companies that fail to act risk reputational
        damage. They can also lose investors' trust. They can also face fines
        for regulatory non-compliance. The delay may signal non compliance and
        may give a signal that the company also lacks commitment to long term
        growth. It also signals that they are not committed to becoming
        sustainable.
        <br />
        <br />
        Starting does not require a massive transformation. Even a basic
        baseline report demonstrate intent, accountability and willingness to
        evolve. If you take early action the investors would feel you are
        future-ready. The company may look aligned with global sustainability
        trends.
        <br />
        <br />
        It is not longer an option to have a{" "}
        {getLink("sustainability report", "/")}. The company needs a
        sustainability report or else it will be in legal and financial
        troubles. The investors will not give funds as they will feel the
        company is not future-ready. If the company doesn't comply with
        government norms they will be fined for it. This will make them lose the
        trust of investors. The stakeholders will feel the company is not
        future-ready and is not involved in saving the planet and following
        enviornmental protection norms. The company has to follow{" "}
        {getLink("ESG reporting standard", "/solutions/esg-reporting")} that is
        recognised by the government. They also have to comply with the norms.
        They need to make a basic report that can be in a pdf form and contain
        charts and imges of their emission levels. They can also include gender
        diversity. This report should contain everything that makes the business
        sustainable in the future.
        <br />
        <br />
        The steps that will help you to make a base line report are : <br />
        <br />
        <b>Step 1: All essential data needs to be collected.</b>
        <p>
          Step 1 involved collecting all the important data. The foundation of
          sustainability reporting lies in collecting important data. The data
          involves utilities, workforce and supply chain. The waste management
          reports should also be collected. The company's carbon footprint
          should be traced.
        </p>
        <p>This may include utilities, workforce and supplier details.</p>
        <p>
          They need to gather data on energy consumption, water usage and waste
          management.
        </p>
        <p>
          Employees training and management details, demographics and diversity
          details need to be included too.
        </p>
        <p>Data on supplier diversity needs to be collected.</p>
        <p>
          Even if the data set is incomplete. It will help to build momentum and
          signal progress.
        </p>
        <p>
          The company can start with whatever is available and add on later on.
          This builds the foundation for more detailed reporting.
        </p>
      </p>
      <p>
        <b>Step 2: Identify ESG material topics.</b>
        <br />
        Not all sustainability issues carry the same weightage. A{" "}
        {getLink(
          "materiality assessment",
          "/solutions/double-materiality-assessment"
        )}{" "}
        can be conducted.
        <br />
        For example: <br />A manufacturing firm may priortize emissions and
        waste reduction. The tech firm may focus on data privacy and workforce
        well being. You can conduct a materiality assessment. This will help
        focus the efforts on the more important parts of your reporting. It will
        ensure that the reports are directed effectively.
      </p>
      <p>
        <b>Step 3: Draft a baseline report</b>
        <br /> A simple PDF which has a dashboard that covers a few KPIs is
        considered valuable. A base line report can be made. It does not need to
        be complex. It can also be a simple PDF. It can highlight KPIs like
        energy usage, carbon footprint and gender diversity. This can also
        include visual charts and graphs. This will help create a transparent
        records. This is the first step company towards a full ESG reporting
        disclosure in the future.
      </p>
      <p>
        <b>Step 4: Communication with the stakeholders should be a priority.</b>
        <br />
        You can publish it, share it internally and tell the investors that you
        are on the right path. If you are transparent it will help create trust.
        Once you have created a baseline report. You should share it widely and
        publish it on your website. You can also circulate it internally and
        share with the stakeholders. Open communication assures them that you
        are committed to continuous improvement. The investor might feel that
        you comply to continuous improvement. It also shows that you are
        committed to growing ethically.
      </p>
      <p>
        <div className="blog-sub-heading">Conclusions </div>
        The {getLink("sustainability reporting", "/")} is not just about
        perfection. It is about sharing your progress. If you start early, you
        can get more investors. You will be able to meet their expectations.
        They can help you earn stakeholders confidence. You can get more
        advanced ESG reporting when your business grows. This will be your
        foundation for ESG reporting. It will show you stakeholders that your
        business is future-proof.
      </p>
      <p>
        CTA: Download free corporate reporting checklist.
        <br />
        {getLink(
          "Top sustainability metrics that should be tracked by every corporation",
          "top-sustainability-metrics-that-should-be-tracked-by-every-corporation"
        )}
      </p>
      <p>
        You should now check out the top sustainability metrics that should be
        tracked by every corporate
      </p>
    </div>
  );
}

export default Blog_50_1;
